import { useQuery } from '@tanstack/react-query';
import { integrationHubApi } from '../api/integrationHubApi';
import type { EndpointListFilter } from '../types/integrationHub';

/**
 * GET /api/eraf/integration-hub/endpoints — 엔드포인트 목록 (INTEGRATION_READ)
 * queryKey: ['integration-hub', 'endpoints', 'list', filters]
 */
export function useEndpoints(filters: EndpointListFilter) {
  return useQuery({
    queryKey: ['integration-hub', 'endpoints', 'list', filters],
    queryFn: () =>
      integrationHubApi.listEndpoints({
        protocol: filters.protocol || undefined,
        enabled: filters.enabled !== '' ? filters.enabled : undefined,
        page: filters.page ?? 0,
        size: filters.size ?? 20,
        sort: filters.sort ?? 'createdAt,desc',
      }),
    staleTime: 30_000,
  });
}
